/**
 * Created by Sebastian Kleine on 11/10/18.
 */

import $ from 'jquery';

class LoginLayer {
	/**
	 * takes Outermost DOM Element
	 *
	 * @param domElement
	 */
	constructor(domElement) {
		const $element = $(domElement);
		const config = {
			openlink: 'geno-login__link',
			closebutton: 'geno-login-layer__close',
			content: 'geno-login-layer',
			state: 'is-hidden'
		};

		this.addToggleEvents($element, config);
	}

	/**
	 * Simple Class Toggler
	 */
	addToggleEvents($element, config) {
		let $layer = $element.find('.' + config.content);

		$element.find('.' + config.openlink).each((index, openlink) => {
			$(openlink).on('click', function(event) {
				$layer.toggleClass(config.state);
				event.stopPropagation();
			});
		});

		$layer.find('.' + config.closebutton).each((index, button) => {
			$(button).on('click', function(event) {
				$layer.addClass(config.state);
				event.stopPropagation();
			});
		});

		/* this.sidebarBtn.on('click', () => {
				this.sidebarContent.toggleClass(this.isHidden);
			});
			*/
	}
}

export default LoginLayer;



// WEBPACK FOOTER //
// ./js/modules/loginLayer.js